import React from "react";
import { X } from "lucide-react";
import { createPortal } from "react-dom";

// Format Date
const formatDate = (dateStr) => {
  if (!dateStr) return "N/A";
  const date = new Date(dateStr);

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const day = String(date.getDate()).padStart(2, "0");
  const month = months[date.getMonth()];
  const year = date.getFullYear();

  return `${day} ${month} ${year}`;
};

// Format Time
const formatTime = (dateStr) => {
  if (!dateStr) return "N/A";
  const date = new Date(dateStr);
  return date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
};

const FranchiseDetailsModal = ({ franchise, onClose }) => {
  if (!franchise) return null;

  const {
    fullName,
    franchiseName,
    email,
    phone,
    address,
    city,
    message,
    status,
    aadharCard,
  } = franchise;

  return createPortal(
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 backdrop-blur-sm overflow-y-auto p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg p-6 relative transition-all duration-300 ease-in-out">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-red-500 transition duration-200"
        >
          <X size={22} />
        </button>

        {/* Title */}
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-6 tracking-wide">
          Franchise Details
        </h2>

        {/* Info Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 text-[15px]">
          <div>
            <p className="text-gray-500 font-medium">Full Name</p>
            <p className="text-gray-900 font-semibold">{fullName}</p>
          </div>
          <div>
            <p className="text-gray-500 font-medium">Franchise Name</p>
            <p className="text-gray-900 font-semibold">{franchiseName}</p>
          </div>
          <div>
            <p className="text-gray-500 font-medium">Email</p>
            <p className="text-blue-600 font-semibold">{email}</p>
          </div>
          <div>
            <p className="text-gray-500 font-medium">Phone</p>
            <p className="text-gray-900 font-semibold">{phone}</p>
          </div>
          <div>
            <p className="text-gray-500 font-medium">Status</p>
            <p
              className={`capitalize font-bold ${
                status === "approved"
                  ? "text-green-600"
                  : status === "rejected"
                  ? "text-red-600"
                  : "text-yellow-600"
              }`}
            >
              {status}
            </p>
          </div>
          <div>
            <p className="text-gray-500 font-medium">Address</p>
            <p className="text-gray-900 font-semibold">{address}</p>
          </div>
          <div>
            <p className="text-gray-500 font-medium">City</p>
            <p className="text-gray-900 font-semibold">{city}</p>
          </div>
          <div>
            <p className="text-gray-500 font-medium">Aadhar Card Number</p>
            <p className="text-gray-900 font-semibold">{aadharCard}</p>
          </div>
          <div className="sm:col-span-2">
            <p className="text-gray-500 font-medium">Message</p>
            <p className="text-gray-900 font-semibold break-words">{message}</p>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default FranchiseDetailsModal;
